interface HeaderProps {
    selectedArea: string;
    bgColor?: string;
    title?: string;
    text?: string
}
  
const Header = ({ selectedArea, bgColor, title, text }: HeaderProps) => {
    return (
    <>
        <div>
            <div className="flex justify-between">
            <p className="text-lg text-color-cai-brown font-bold ml-4">{title}</p>
            <p className="text-lg text-color-cai-blue font-bold mr-4">
                {selectedArea}
            </p>
            </div>
            <div className="border-t border-color-cai-brown mt-2"></div>
        </div>
        {bgColor && text &&
        <div className={`border ${bgColor} rounded-md py-2 mx-2 my-2 flex flex-col items-center justify-center`}>
            <h2 className="font-bold text-white text-lg text-center">{text}</h2>
        </div>
        }
    </>  
    );
};
  
export default Header;